import { Apple, Play } from 'lucide-react';

/**
 * "Coming Soon" App Store + Google Play badges.
 * Non-interactive placeholders shown until store listings go live.
 */
export const AppStoreBadges = ({ idSuffix = 'default', size = 'md' }) => {
  const sizeCls = size === 'sm' ? 'h-12 px-4 text-xs' : 'h-14 px-5 text-sm';
  return (
    <div className="flex flex-col sm:flex-row items-center gap-3" data-testid={`app-store-badges-${idSuffix}`}>
      <div
        className={`relative flex items-center gap-3 rounded-2xl bg-foreground text-background ${sizeCls} opacity-70 select-none cursor-not-allowed`}
        aria-disabled="true"
        data-testid={`ios-badge-${idSuffix}`}
      >
        <Apple className="h-6 w-6" strokeWidth={1.5} />
        <div className="flex flex-col leading-none">
          <span className="text-[9px] opacity-70 uppercase tracking-wider">Coming soon on</span>
          <span className="text-base font-semibold">App Store</span>
        </div>
        <span className="absolute -top-2 -right-2 px-2 py-0.5 rounded-full bg-secondary text-secondary-foreground text-[9px] font-semibold uppercase tracking-wider">Soon</span>
      </div>
      <div
        className={`relative flex items-center gap-3 rounded-2xl bg-foreground text-background ${sizeCls} opacity-70 select-none cursor-not-allowed`}
        aria-disabled="true"
        data-testid={`android-badge-${idSuffix}`}
      >
        <Play className="h-6 w-6" strokeWidth={1.5} />
        <div className="flex flex-col leading-none">
          <span className="text-[9px] opacity-70 uppercase tracking-wider">Coming soon on</span>
          <span className="text-base font-semibold">Google Play</span>
        </div>
        <span className="absolute -top-2 -right-2 px-2 py-0.5 rounded-full bg-secondary text-secondary-foreground text-[9px] font-semibold uppercase tracking-wider">Soon</span>
      </div>
    </div>
  );
};
